// extracted by mini-css-extract-plugin
export default {"wrap":"kG-z","fullWidth":"lG-z","hideOnDesktop":"mG-z","content":"nG-z","hasOpenedNav":"oG-z","crumbsList":"pG-z","dropdownsWrap":"qG-z"};